var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPdfIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 2,
    fill: "#CB0606"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 5H3.67755C3.97933 5 4.25448 5.0675 4.50301 5.20251C4.75153 5.33287 4.9468 5.51909 5.08882 5.76117C5.23083 5.9986 5.30184 6.27095 5.30184 6.57821C5.30184 6.88547 5.23083 7.16015 5.08882 7.40223C4.9468 7.64432 4.75153 7.83287 4.50301 7.96788C4.25448 8.09823 3.97933 8.16341 3.67755 8.16341H2.89869V10H2V5ZM3.70417 7.26955C3.92607 7.26955 4.09915 7.20205 4.22341 7.06704C4.35212 6.93203 4.41647 6.76909 4.41647 6.57821C4.41647 6.38734 4.35212 6.22672 4.22341 6.09637C4.09915 5.96136 3.92607 5.89385 3.70417 5.89385H2.89869V7.26955H3.70417Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.06307 5H7.67404C8.17109 5 8.6038 5.10475 8.97215 5.31425C9.3405 5.52374 9.62452 5.81704 9.82423 6.19413C10.0239 6.57123 10.1238 7.00652 10.1238 7.5C10.1238 7.99348 10.0239 8.42877 9.82423 8.80587C9.62452 9.18296 9.3405 9.47626 8.97215 9.68575C8.6038 9.89525 8.17109 10 7.67404 10H6.06307V5ZM7.6341 9.10615C8.14891 9.10615 8.54166 8.96415 8.81238 8.68017C9.08309 8.39153 9.21845 7.99814 9.21845 7.5C9.21845 7.00186 9.08309 6.6108 8.81238 6.32682C8.54166 6.03818 8.14891 5.89385 7.6341 5.89385H6.96175V9.10615H7.6341Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9778 5H14V5.89385H11.8764V7.10894H13.787V8.00279H11.8764V10H10.9778V5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfIcon);
export default __webpack_public_path__ + "static/media/pdfIcon.92c7c1867ce328fe602845fa8bf56865.svg";
export { ForwardRef as ReactComponent };